/*
 * md-buy-bar.js
 * Mostra a barra sticky quando o botao ATC original sai da viewport.
 * Clique na barra = proxy-click no botao ATC original. Mantem toda logica
 * de variante, quantidade e personalizacao no form principal.
 */

(function () {
  'use strict';

  var SEL_BAR = '[data-md-bb]';
  var SEL_CTA = '[data-md-bb-cta]';
  var SEL_PRECO = '[data-md-bb-preco]';
  var SEL_FORM_BTNS = '.product-form__buttons';
  var SEL_FORM_SUBMIT = '.product-form__submit';
  var SEL_PRECO_FONTE =
    'product-info .price .price__container .price-item--sale,' +
    'product-info .price .price__container .price-item--regular,' +
    '.price .price__container .price-item--sale,' +
    '.price .price__container .price-item--regular,' +
    '[data-md-bb-preco-fonte]';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function proxyClick(mainBtn) {
    if (!mainBtn || mainBtn.disabled) return;
    mainBtn.click();
  }

  function syncPreco(bar) {
    var alvo = qs(SEL_PRECO, bar);
    var fonte = qs(SEL_PRECO_FONTE);
    if (alvo && fonte && fonte.textContent) {
      var txt = fonte.textContent.replace(/\s+/g, ' ').trim();
      if (txt) {
        alvo.textContent = txt;
      }
    }
  }

  function syncEstado(bar, mainBtn) {
    var cta = qs(SEL_CTA, bar);
    if (!cta || !mainBtn) return;
    cta.disabled = !!mainBtn.disabled;
    var mainLabel =
      mainBtn.querySelector('span:not(.loading-overlay__spinner)') ||
      mainBtn.querySelector('span');
    if (mainLabel && mainLabel.textContent) {
      var txt = mainLabel.textContent.trim();
      var ctaLabel = cta.querySelector('.md-bb__cta-label');
      if (ctaLabel && txt) {
        ctaLabel.textContent = txt;
      }
    }
  }

  function show(bar) {
    bar.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      bar.classList.add('md-bb--on');
    });
  }

  function hide(bar) {
    bar.classList.remove('md-bb--on');
    bar.setAttribute('aria-hidden', 'true');
  }

  function initBar(bar) {
    if (bar.dataset.mdBbInit === '1') return;
    bar.dataset.mdBbInit = '1';

    var mainBtnsWrap = qs(SEL_FORM_BTNS);
    var mainBtn = mainBtnsWrap
      ? qs(SEL_FORM_SUBMIT, mainBtnsWrap)
      : qs(SEL_FORM_SUBMIT);

    if (!mainBtnsWrap || !mainBtn) {
      return;
    }

    var cta = qs(SEL_CTA, bar);
    if (cta) {
      cta.addEventListener('click', function (ev) {
        ev.preventDefault();
        proxyClick(mainBtn);
      });
    }

    syncPreco(bar);
    syncEstado(bar, mainBtn);

    if (typeof window.IntersectionObserver !== 'function') {
      return;
    }

    var io = new window.IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var e = entries[i];
          if (e.isIntersecting) {
            hide(bar);
          } else {
            var rect = e.boundingClientRect;
            if (rect.top < 0) {
              show(bar);
            } else {
              hide(bar);
            }
          }
        }
      },
      { threshold: 0, rootMargin: '0px 0px -1px 0px' }
    );

    io.observe(mainBtnsWrap);

    if (typeof window.MutationObserver === 'function') {
      var mo = new window.MutationObserver(function () {
        syncPreco(bar);
        syncEstado(bar, mainBtn);
      });
      mo.observe(mainBtn, { attributes: true, attributeFilter: ['disabled'] });
      var priceWrap = document.querySelector('product-info .price') ||
        document.querySelector('.price');
      if (priceWrap) {
        mo.observe(priceWrap, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
    }

    document.addEventListener('shopify:section:load', function () {
      var novo = qs(SEL_FORM_SUBMIT);
      if (novo) {
        syncPreco(bar);
        syncEstado(bar, novo);
      }
    });
  }

  function initAll() {
    var bars = document.querySelectorAll(SEL_BAR);
    for (var i = 0; i < bars.length; i++) {
      initBar(bars[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
